import type { ReactNode } from 'react'
import { TON, type Ton } from './TonuriB4L'

export interface CardSelector<K extends string> {
  cheie: K
  eticheta: string
  valoare: ReactNode
  detaliu?: ReactNode
  ton: Ton
}

/**
 * Cardurile de sus ale unui ecran de lucru: fiecare spune cat e de facut si, la clic, deschide
 * dedesubt lista lui (Madalin, 12.10.2026: „fiecare card sa deschida la click continutul aferent
 * (...) si UI-ul sa aiba element de diferentiere la selectie"). Se vede o singura lista odata.
 *
 * Cardul ales: fundal in tonul lui, contur plin, ridicat, cu o sageata spre continut.
 */
export function CarduriSelector<K extends string>({
  carduri,
  ales,
  onAlege,
  eticheta = 'Alege lista',
}: {
  carduri: CardSelector<K>[]
  ales: K
  onAlege: (k: K) => void
  eticheta?: string
}) {
  return (
    <div
      role="tablist"
      aria-label={eticheta}
      className="grid gap-3 [grid-template-columns:repeat(auto-fit,minmax(min(100%,150px),1fr))] sm:[grid-template-columns:repeat(auto-fit,minmax(210px,1fr))]"
    >
      {carduri.map((c) => {
        const t = TON[c.ton]
        const activ = c.cheie === ales
        return (
          <button
            key={c.cheie}
            type="button"
            role="tab"
            aria-selected={activ}
            onClick={() => onAlege(c.cheie)}
            className={`relative grid gap-0.5 rounded-xl border border-l-4 p-3.5 text-left transition motion-reduce:transition-none ${t.bara} ${
              activ
                ? `${t.fundal} ${t.contur} -translate-y-0.5 shadow-lg ring-1 motion-reduce:translate-y-0`
                : 'border-b4l-border bg-b4l-surface hover:bg-b4l-bg-soft'
            }`}
          >
            <span className={`text-[11px] font-semibold uppercase tracking-wider ${t.text}`}>
              {c.eticheta}
            </span>
            <span className="text-2xl font-semibold tabular-nums text-b4l-text">{c.valoare}</span>
            {c.detaliu && <span className="text-xs text-b4l-text-muted">{c.detaliu}</span>}
            {activ && (
              <span
                aria-hidden
                className={`absolute -bottom-[7px] left-1/2 h-3 w-3 -translate-x-1/2 rotate-45 border-b border-r ${t.fundal} ${t.contur}`}
              />
            )}
          </button>
        )
      })}
    </div>
  )
}
